import { render } from "./VisitesList.vue?vue&type=template&id=6baa2ffd"
import script from "./VisitesList.vue?vue&type=script&lang=js"
export * from "./VisitesList.vue?vue&type=script&lang=js"

import "./VisitesList.vue?vue&type=style&index=0&id=6baa2ffd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__